import { interpolate } from 'd3-interpolate'
import {get as getProjection} from '..'
import Transformer from './transformer'
import * as geo from 'd3-geo'

class MultiFeatureZoom extends Transformer {

  static match (d0, d1, opts) {
    if (d0) {
      // This isn't used if a node is exiting. It's only used when adjusting
      // the zoom of the node with `opts.zoomTo`
      return false
    }

    return opts.zoomTo && opts.zoomTo.length ||  // Some zoomTo was defined, always use this transformer
      ((!opts.zoomTo || opts.zoomTo.length == 0) && d1.zoomedTo) // No longer zoomed, previously was zoomed
  }

  constructor (enter, exit, opts) {
    super(enter, exit, opts)
    let data = enter.datum()

    if (!data.projection) {
      // This multi feature is being load as an initial render, not a
      // transformation
      data.projection = getProjection(data.node, data.geojson, opts)
      data.path = geo.geoPath().projection(data.projection)
    }

    let s0 = data.projection.scale()
      , t0 = data.projection.translate()

    // Fit the projection to these features
    data.projection.fitSize([opts.width, opts.height], this._buildFeatureCollection(opts.zoomTo, data.geojson))

    data.zoomedTo = opts.zoomTo?.length ? opts.zoomTo : null

    this.interpolaters = {
      translate: interpolate(t0, data.projection.translate()),
      scale: interpolate(s0, data.projection.scale())
    }

    this.projection = data.projection
    this.path = data.path

    this.enter = enter
  }

  transform (t) {
    this.projection
        .scale(this.interpolaters.scale(t))
        .translate(this.interpolaters.translate(t))

    this.enter.selectAll('path').attr('d', this.path)
  }

}

export default MultiFeatureZoom
